import { render } from "./MyMusicXml.vue?vue&type=template&id=22d08374"
import script from "./MyMusicXml.vue?vue&type=script&lang=js"
export * from "./MyMusicXml.vue?vue&type=script&lang=js"

import "./MyMusicXml.vue?vue&type=style&index=0&id=22d08374&lang=less"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__